import { Search } from 'lucide-react'

interface ChatSearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  ariaLabel?: string
}

export function ChatSearchInput({
  value, onChange, placeholder = 'Chat suchen...', ariaLabel = 'Chat suchen',
}: ChatSearchInputProps) {
  return (
    <div className="p-3 border-b border-gray-200">
      <div className="relative">
        <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          type="text"
          aria-label={ariaLabel}
          value={value}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
    </div>
  )
}
